import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SchoolInsuredChild } from "@shared/models/policy-details";
import { DividerModule } from "primeng/divider";

@Component({
  selector: "app-scholar-insurance-mrh",
  standalone: true,
  imports: [CommonModule, TranslateModule, DividerModule],
  templateUrl: "./scholar-insurance-mrh.component.html",
  styleUrl: "./scholar-insurance-mrh.component.scss",
})
export class ScholarInsuranceMrhComponent {
  @Input() children!: SchoolInsuredChild[];
}
